import { useAuth } from "auth/useAuth";

/** Hook to identify whether Mason integration is in effect. */
export function useMasonFlag() {
    const loginResult = useAuth((state) => state.loginResult);

    // It's not valid to be using this somewhere that can be accessed without logging in.
    if (!loginResult) throw new Error("Mason status not available when not logged in.");

    return loginResult.pmsIntegrated;
}
